// extracted by mini-css-extract-plugin
export var card = "_lb-5";
export var cardSelected = "_lb-4";
export var image = "_lb-3";
export var modal = "_lb-0";
export var modalContent = "_lb-1";
export var table = "_lb-2";